import React, { useEffect, useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import { createPortal } from 'react-dom';
import OrganizationLabel from './OrganizationLabel';

interface IProps {
  organizations: any[];
  disabled?: boolean;
  onChangeToText: any;
  frame?: boolean;
}

const OrganizationLabelList: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { organizations, disabled, onChangeToText, frame } = props;

  const [isText, setIsText] = useState(false);
  const [width, setWidth] = useState(0);
  const [seeMore, setSeeMore] = useState(false);
  const [orgsToShow, setOrgsToShow] = useState([]);
  const [moreOrgs, setMoreOrgs] = useState([]);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | number;

    const analizeTextOrgs = () => {
      let lines = 1;
      let lineWidth = 0;
      const preOrgs: any[] = [];
      const preMoreOrgs: any[] = [];

      organizations.forEach((org) => {
        const orgWidth = org.organization.title.length * 7 + 9;
        if (lineWidth + orgWidth < width) {
          lineWidth += orgWidth;
        } else {
          lines += 1;
          lineWidth = orgWidth;
        }
        if (lines > 4) {
          preMoreOrgs.push(org);
        } else preOrgs.push(org);
      });
      setOrgsToShow(preOrgs);
      setMoreOrgs(preMoreOrgs);
    };

    const analizeOrgs = () => {
      let lines = 1;
      let lineWidth = 0;

      organizations.forEach((org) => {
        const orgWidth = org.organization.title.length * 7 + 60;
        if (lineWidth + orgWidth < width) {
          lineWidth += orgWidth;
        } else {
          lines += 1;
          lineWidth = orgWidth;
        }
      });

      if (lines > 3) {
        onChangeToText(true);
        setIsText(true);
        analizeTextOrgs();
      } else {
        onChangeToText(false);
        setIsText(false);
        setOrgsToShow(organizations);
      }
    };

    const onResize = () => {
      setOrgsToShow([]);
      setMoreOrgs([]);
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        setWidth(document?.getElementById('headerHosts')?.clientWidth);
        if (width > 0) {
          analizeOrgs();
        }
      }, 600);
    };

    if (!orgsToShow.length || width !== document?.getElementById('headerHosts')?.clientWidth) {
      onResize();
    }

    const prevWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth !== prevWidth) {
        onResize();
      }
    });
    return () => {
      window.removeEventListener('resize', () => {
        if (window.innerWidth !== prevWidth) {
          onResize();
        }
      });
      clearTimeout(timeout as NodeJS.Timeout);
    };
  }, [onChangeToText, organizations, orgsToShow.length, width]);

  const orgLabels = useMemo(() => {
    if (!isText)
      return (
        <>
          {orgsToShow.map((host, index) => (
            <OrganizationLabel
              organizationInfo={host}
              index={index}
              length={orgsToShow.length}
              disabled={disabled}
              text={isText}
            />
          ))}
        </>
      );
    return moreOrgs.length > 0 && !seeMore ? (
      <>
        {orgsToShow.map((host, index) => (
          <OrganizationLabel
            organizationInfo={host}
            index={index}
            length={orgsToShow.length}
            disabled={disabled}
            text={isText}
          />
        ))}
        <span>
          <Typography
            variant="body2"
            color="primary"
            style={{ cursor: 'pointer', fontWeight: 600 }}
            onClick={() => setSeeMore(true)}
          >
            ...see more
          </Typography>
        </span>
      </>
    ) : (
      <>
        {orgsToShow.map((host, index) => (
          <OrganizationLabel
            organizationInfo={host}
            index={index}
            length={orgsToShow.length + (moreOrgs.length ? 1 : 0)}
            disabled={disabled}
            text={isText}
          />
        ))}
        {moreOrgs.map((host, index) => (
          <OrganizationLabel
            organizationInfo={host}
            index={index}
            length={moreOrgs.length}
            disabled={disabled}
            text={isText}
          />
        ))}
        {seeMore && (
          <span>
            <Typography
              variant="body2"
              color="primary"
              style={{ cursor: 'pointer', fontWeight: 600 }}
              onClick={() => setSeeMore(false)}
            >
              ...see less
            </Typography>
          </span>
        )}
      </>
    );
  }, [disabled, isText, moreOrgs, orgsToShow, seeMore]);

  if (frame && typeof document === 'object' && document.getElementById('headerHosts')) {
    return createPortal(orgLabels, document.getElementById('headerHosts'));
  }
  return orgsToShow.length > 0 ? orgLabels : <div />;
};

export default OrganizationLabelList;
